<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Flux</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Kim Fielding</p>
<p class="P_Norm-NoIndent"> </p>
<p class="P_Norm-NoIndent">Ennek Trilogy: Book 2</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Ennek, the son of Praesidium’s Chief, has rescued Miner from a terrible fate: suspension in a dreamless frozen state called Stasis, the punishment for traitors. As the two men flee Praesidium by sea, their adventures are only beginning. Although they may be free from the tyranny of their homeland, new difficulties await them as Miner faces the continuing consequences of his slavery and Ennek struggles with controlling his newfound powers as a wizard.</p>
<p class="P_Normal">Now fugitives, Ennek and Miner encounter challenges both human and magical as they explore new lands and their deepening relationship with each other.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?0e7e3728